export default __webpack_public_path__ + "static/media/notification.8f876f63.svg";